/**
 * A row is the issues of one page that started on the same day: they share the day, so traffic lost
 * and the change points are the same for all of them.
 */
export const rowsOf = (page, issues) => {
    const bySince = new Map();
    for (const issue of issues) bySince.set(issue.since, [...(bySince.get(issue.since) || []), issue]);
    return [...bySince.values()].map((sameDay) => ({ page, issues: sameDay, issue: sameDay[0] }));
};

/** By PageWeight, the most important page first. */
export const byPageWeight = (a, b) => a.page.pageWeight - b.page.pageWeight;

/** By the share of the site's month on the row's criticality, most first, so rows with no loss go last; ties by PageWeight. */
export const byImpact = (a, b) => b.criticality.percent - a.criticality.percent || byPageWeight(a, b);

/**
 * What a group of rows cost, as the Breakdown card writes it: its impact, the sum of its rows' larger share of the
 * site's month (the share on each row's pill), and its loss a month on each of `measures`, by the measure's key.
 */
export const lossOf = (rows, measures) => ({
    impact: rows.reduce((total, { criticality }) => total + criticality.percent, 0),
    lostPerMonth: Object.fromEntries(measures.map(({ key, readingOf }) => [
        key,
        rows.map(({ issue }) => readingOf(issue)?.lost).filter((each) => each > 0).reduce((total, each) => total + each, 0) * 30,
    ])),
});

/** Whether a group of rows lost something on any measure. */
export const hasLoss = ({ lostPerMonth }) => Object.values(lostPerMonth).some((each) => each > 0);
